import { isEuropeanCountry, isGreatBritain, isCanada } from '@/helpers/address'

export function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n)
}

export function isFunction(obj) {
  return typeof obj === 'function'
}

export function isPhoneNumber(n) {
  return /^[+]?[(]?[0-9]{1,4}[)]?[-\s\.\/0-9]*$/.test(n) // eslint-disable-line no-useless-escape
}

export function isAllCapsWithoutSpaces(str) {
  return /^[A-Z]+$/.test(str)
}

export function hasNumber(value) {
  return /\d/.test(value)
}

/**
 * Checks if every element in the given array contains the given keys.
 *
 * @param {Array} array - Array to validate
 * @param {Array} keys - List of keys that need to be present
 */
export function arrayElementsContainKeys(array, keys) {
  return array.every(object => keys.every(key => object.hasOwnProperty(key)))
}

// Should be aligned with the backend validation:
// app/services/validations/shippability_checker.rb
export function isBritishForcesPostOfficeBox(value, countryIso) {
  const ukPoBoxIndicators = { number: 'bf1', code: 'bfpo' }
  const regex = new RegExp(`\\b(${ukPoBoxIndicators.number}|${ukPoBoxIndicators.code})\\b`, 'i')
  return /^gb$/i.test(countryIso) && regex.test(value)
}

export function isArmyPostOfficeBox(value, countryIso) {
  const apoBoxIndicators = ['apo', 'fpo', 'dpo']
  return /^us/i.test(countryIso) && apoBoxIndicators.indexOf(value.toLowerCase().trim()) >= 0
}

export function isPostOfficeBox(value, countryIso) {
  // eslint-disable-next-line no-useless-escape
  const poBoxIndicator = /(?:P(?:ost(?:al)?)?[\.\-\s]*(?:(?:O(?:ffice)?[\.\-\s]*)?B(?:ox|in|\b|\d)|o(?:ffice|\b)(?:[-\s]*\d)|code)|box[-\s\b]*\d)/i
  return /^(us|au|ca)/i.test(countryIso) && poBoxIndicator.test(value)
}

export function requireHouseNumber(countryIso) {
  return isEuropeanCountry(countryIso) || isGreatBritain(countryIso) || isCanada(countryIso)
}

export function isLessThanSixChars(value) {
  return value.length < 6
}

// Also allows " ", "-", "'" and "."
export const isOnlyLetters = value => /^[^0-9_!¡?÷?¿/\\+=@#$£%ˆ&*(){}|~<>;:[\]]*$/.test(value)
